const observer = new MutationObserver(() => {
  const widgets = document.querySelectorAll('.yotpo-reviews-star-ratings-widget');

  widgets.forEach(widget => {
    const ratingEl = widget.querySelector('[aria-label]');
    if (!ratingEl) return;

    const text = ratingEl.getAttribute('aria-label');
    const match = text.match(/([\d.]+)\s*out/);
    if (!match) return;

    const rating = parseFloat(match[1]);

    if (rating <= 3) {
      widget.style.opacity = '0';
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("DOMContentLoaded", () => {
  const logoutLink = document.querySelector('a[href*="/account/logout"]');

  if (!logoutLink) return;

  logoutLink.addEventListener("click", async (e) => {
    e.preventDefault();

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const updates = {};

      cart.items.forEach(item => {
        if (
          item.product_id == window.eliteProductId ||
          item.product_id == window.eliteRenewId
        ) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }

    } catch (err) {
      console.error('Cart cleanup error:', err);
    } finally {
      // Always proceed with logout (even if API fails)
      window.location.href = logoutLink.href;
    }
  });
});






// membership page js
document.addEventListener("DOMContentLoaded", () => {
    const details_button = document.querySelectorAll(".cc-sites-access-button");

    details_button.forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault();

            const content = JSON.parse(item.dataset.content);

            // Generate the HTML for the popup
            const template = `
          <div class="cc-site-popup-block">
            <button class="cc-site-popup-close-button">
              <img src="https://cdn.shopify.com/s/files/1/0925/7290/files/close-button.png" class="img-responsive" />
            </button>
            <div class="cc-site-popup-content">
              <div class="cc-site-popup-logo">
                <img src="${content.logo}" class="img-responsive" />
              </div>
              <div class="cc-site-popup-list">
                <h3>${content.club.heading}</h3>
                <ul>
                  ${content.club.list
                    .map(
                        (item) => `
                      <li>
                        <img src="https://cdn.shopify.com/s/files/1/0925/7290/files/red-tick.png?v=1732415833" class="img-responsive" />
                        <span>${item}</span>
                      </li>`
                    )
                    .join("")}
                </ul>
              </div>
              <div class="cc-site-popup-list">
                <h3>${content.elite.heading}</h3>
                <ul>
                  ${content.elite.list
                    .map(
                        (item) => `
                      <li>
                        <img src="https://cdn.shopify.com/s/files/1/0925/7290/files/blue-tick.png?v=1732415833" class="img-responsive" />
                        <span>${item}</span>
                      </li>`
                    )
                    .join("")}
                </ul>
              </div>
            </div>
             <button class="cc-site-popup-close-button-text">Close</button>
          </div>
        `;

            // Append the popup to the body
            document.body.insertAdjacentHTML("afterbegin", template);

            // Attach event listener to close the popup
            const popup = document.querySelector(".cc-site-popup-block");
            const closeButtons = popup.querySelectorAll(".cc-site-popup-close-button, .cc-site-popup-close-button-text");

            closeButtons.forEach((btn) => {
                btn.addEventListener("click", () => {
                    popup.remove();
                });
            });
        });
    });
});